var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15 4.18933L6.28783 13.9372L1 8.80961L3.2213 6.5189L6.12332 9.33298L12.6209 2.06299L15 4.18933Z","fill":_vm.fill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }